var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKhronos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 850.39 850.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #ff0452;\n      }\n\n      .st2 {\n        display: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 0,
    y: 0,
    width: 850.39,
    height: 850.39
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.49,369.66c1.81,14.61-1.33,294.58,0,309.57h20.15v-309.57c0-45.97,113.17-138.46,144.09-178.32,2.03-2.61,15.2-20.4,13.08-22.16-97.68,12.92-198.68-32.54-295.3-26.31-27.88,1.8-53.67,1.91-36.66,34.85,30.05,58.18,146.05,122.5,154.64,191.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M589.8,779.73c-51.36-150.2-278.4-149.04-332.49,0h332.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.06,649.78c15.81-107.02,197.13-160.38,155.21-286.24-12.9-38.74-96.63-109.43-126.03-146-43.86-54.55-29.92-113.41-33.22-179.37l105.57-9.82h-115.66v143.83c0,43.65,123.83,137.86,149.99,180.48,57.32,93.4-84.89,176.23-133.8,242.76-7.38,10.04-16.19,25.35-16.19,38.21v186.4h135s-124.93-10.06-124.93-10.06c3.45-50.68-3.27-110.54,4.07-160.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M635.15,197.39c3.7-7.83,6.29-20.48,7.1-29.17,1.11-11.94,2.3-96.53-.6-122.37l-1.43-17.49h-113.54l105.45,9.82c-3.65,3.54-.8,87.73-2.07,101.73-10.59,116.94-168.46,160.28-163.27,270.17,4.06,86.01,139.84,145.85,158.33,226.55,11.68,50.98,3.37,118.49,6.12,171.46l-120.01,11.95,130.97,2.03v-188.41c0-79.34-223.84-168.6-149.99-280.97,29.64-45.09,122.64-112.32,142.95-155.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhronos);
export default __webpack_public_path__ + "static/media/khronos.397e3b42b0e9c73a7d3d3c87333c84f5.svg";
export { ForwardRef as ReactComponent };